export default __webpack_public_path__ + "static/media/news.08ac0951.svg";